import { Stack, PrimaryButton } from '@fluentui/react'
import { DashboardFilters, Plan, UserFilterOption } from '../../api/models'
import DateRangeFilter from './DateRangeFilter'
import PlanFilter from './PlanFilter'
import UserFilter from './UserFilter'

type FilterBarProps = {
  filters: DashboardFilters
  plans: Plan[]
  users: UserFilterOption[]
  onFiltersChange: (filters: DashboardFilters) => void
  onApply: () => void
  isLoading: boolean
}

const FilterBar = ({ filters, plans, users, onFiltersChange, onApply, isLoading }: FilterBarProps) => {
  return (
    <Stack
      horizontal
      verticalAlign="end"
      tokens={{ childrenGap: 16 }}
      styles={{
        root: {
          padding: '16px 20px',
          backgroundColor: '#fff',
          borderRadius: 8,
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          flexWrap: 'wrap',
        },
      }}
    >
      <DateRangeFilter
        startDate={filters.startDate || ''}
        endDate={filters.endDate || ''}
        onStartDateChange={(date) => onFiltersChange({ ...filters, startDate: date })}
        onEndDateChange={(date) => onFiltersChange({ ...filters, endDate: date })}
      />
      <PlanFilter
        plans={plans}
        selectedPlanId={filters.planId}
        onChange={(planId) => onFiltersChange({ ...filters, planId })}
      />
      <UserFilter
        users={users}
        selectedUserId={filters.userId}
        onChange={(userId) => onFiltersChange({ ...filters, userId })}
      />
      <PrimaryButton text="Apply Filters" onClick={onApply} disabled={isLoading} />
    </Stack>
  )
}

export default FilterBar
